import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import NavModal from '../NavModal';

class Burger extends React.Component {
  constructor() {
    super()
  }

  render() {
    return (
      <MenuButton expanded={this.props.visible} onClick={this.props.onClick}>
  			<TopLine expanded={this.props.visible} />
  			<MiddleLine expanded={this.props.visible} />
  			<BottomLine expanded={this.props.visible} />
      </MenuButton>
    )
  }
}

export default Burger;

const MenuButton = styled.div`
	height: 46px;
	width: 46px;
	background: ${props =>
    (props.expanded === true && 'mediumpurple')
    || '#333' };
	${'' /* margin: auto; */}
	transition: 0.2s;
	${'' /* box-sizing: border-box; */}
  display: none;
  padding-right: 5px;
  position: relative;
  overflow: hidden;
  @media (max-width: 625px) {
    display: inline-block;
  }
`;

const Line = styled.div`
  width: 25px;
  height: 2px;
  margin: calc(50% - 2px) 11px;
  background: white;
  display: inline-block;
  transition: 0.3s;
  top: 0;
  left: 0;
  position: absolute;
`;

const TopLine = Line.extend`
  top: ${props =>
  (props.expanded === true && '0px')
  || '-7px' };
  transform: ${props =>
  (props.expanded === true && 'rotate(45deg)')
  || '' };
`;

const MiddleLine = Line.extend`
  background: ${props =>
    (props.expanded === true && 'none')
    || 'white' };
`;

const BottomLine = Line.extend`
  top: ${props =>
  (props.expanded === true && '0px')
  || '7px' };
  transform: ${props =>
  (props.expanded === true && 'rotate(-45deg)')
  || '' };
`;



// WEBPACK FOOTER //
// ./src/components/Burger/index.js